import { Pipe } from "@angular/core";

@Pipe({
    name: 'statesFormat',
    standalone: false
})
export class StatesFormatePipe {
  transform(states: string[]) {
    if (!states || !states.length) return '';
    if (states.length == 1) return states[0];
    if (states.length == 2) return `${states[0]} and ${states[1]}`;
    let firstStates = states.splice(0, states.length - 1).join(', ');
    return `${firstStates}, and ${states[states.length - 1]}`;
  };
};